import React from 'react';

import Style from './Footer.module.css';

import { Button } from '../../atoms';
import ImageLoader from '../../molecules/Image';

function Footer({ homePage, vendorPage }) {
  return (
    <>
      <div className='container '>
        <div className={`${Style.footerContainer} row`}>
          <div className={`${Style.marginAuto} col-lg-3 col-12`}>
            <img src='/images/login/logo.svg' />
            <div className={Style.footerText1}>3rd & 4th Floor, HustleHub H1904, 1502, 19th Main Rd, 1st Sector, HSR Layout, Bengaluru, Karnataka 560102</div>
            <div className={Style.footerText2}>Email: expert@awign.com</div>
          </div>
          <div className={Style.flexDynamic} />
          {vendorPage ? null : (
            <div className={`${Style.footerText3} col-lg-2 col-12`}>
              <ImageLoader className='my-3' height={136} src='/images/footer-icons/amico.svg' width={169} />
              <p>Looking To Join Our Vendor Network</p>
              <div className={Style.flexDynamic} />
              <a href='/vendor'>
                <Button className='general-style-2 marginAuto'>Join as a Vendor</Button>
              </a>
            </div>
          )}
          <div className={`${Style.footerText3} col-lg-2 col-12`}>
            <ImageLoader className='my-3' height={136} src='/images/footer-icons/interview.svg' width={169} />
            <p>Looking to Hire Talent?</p>
            <div className={Style.flexDynamic} />
            <a href='https://awignexpert.com/clients/' rel='noreferrer' target='_blank'>
              <Button className='general-style-2 marginAuto'>Hire Talent</Button>
            </a>
          </div>
          {homePage ? (
            <div className={`${Style.footerText3} col-lg-2 col-12`}>
              <ImageLoader className='my-3' height={136} src='/images/footer-icons/browse-jobs.svg' width={169} />
              <p>Are you an Individual Candidate?</p>
              <div className={Style.flexDynamic} />
              <a href='/jobs/explore'>
                <Button className='general-style-2 marginAuto'>Browse Jobs</Button>
              </a>
            </div>
          ) : null}
        </div>
      </div>
      <div className='bg-blue'>
        <div className='container padding0 '>
          <div className={Style.footerBottom}>
            <div className={Style.footerBottomText}>
              <a className='white' href='/terms-and-conditions'>
                Terms and Conditions
              </a>
            </div>
            <div className={Style.footerBottomText}>
              <a className='white' href='/privacy-policy'>
                Privacy Policy
              </a>
            </div>
            <div className={Style.footerBottomText}>
              <a className='white' href='/fraud-advisory'>
                Fraud Advisory
              </a>
            </div>
            <div className={`${Style.footerBottomText} bl-white`}>
              <a className='white' href='/admin/login'>
                Admin login
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
